export default __webpack_public_path__ + "static/media/production.2741c1f4.svg";